<template>
  <div class="live-list">

      <video-list-skeleton v-if="loading" style="margin-bottom: 100vh"></video-list-skeleton>

      <div class="search">
          <van-search v-model="value" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
      </div>

      <div class="tags">
          <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
              <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
          </van-tabs>
          <div class="clear"></div>
      </div>

      <div class="swipe">
          <van-swipe :autoplay="3000" indicator-color="#fff">
              <van-swipe-item v-for="(item,i) in banners" :key="i">
                  <a :href="item.target_url.replace('https://dr-yyh.com','https://dr-yyh.com')">
                    <img :src="item.img" alt="">
                  </a>
              </van-swipe-item>
          </van-swipe>
      </div>

      <div style="margin-top: 20px" v-if="study.length > 0">
          <div class="live-list-section-title">高博内训学术专区</div>
          <div class="live-list-section" style="margin-top: 22px">
              <van-row @click="go_detail(item)" v-for="item in study" :key="item.id">
                  <div class="live-list-section-box">
                      <div class="live-list-section-left">
                          <van-image
                              class="live-list-section-left-img"
                              fit="contain"
                              :src="item.cover_img"
                          />
                          <img v-if="item.type == 2" class="live-list-section-left-zl" src="/static/two/icon_list_tag_subject_live.svg" alt="">
                          <img v-else class="live-list-section-left-zl" src="/static/two/icon_list_tag_live_history.svg" alt="">
                          <div class="live-list-section-left-time"><span>{{item.duration_format}}</span></div>
                      </div>
                      <div class="live-list-section-right">
                          <div class="live-list-section-right-title">{{item.title}}</div>
                          <div v-if="item.type==2" class="live-list-section-right-detail">已开展{{item.current_count}}期 | 共{{item.live_count}}期</div>
                          <div v-else class="live-list-section-right-detail">{{item.view_count}}人观看</div>
                      </div>
                  </div>
              </van-row>
          </div>
          <div class="van-list__finished-text" v-if="backs.length > 0 && page === total_page">没有更多了</div>
          <div v-else-if="study.length > 0 && study_total_page > study_page" class="finish-more" @click="fetch_more()">查看更多</div>
      </div>

      <van-tabbar class="home-footer" :border="false" :fixed="true" :safe-area-inset-bottom="true" v-model="tabbar_active" active-color="#D3172E">
          <van-tabbar-item to="/">
              <span class="home-footer-span-else">首页</span>
              <template #icon="props">
                  <div class="home-footer-icon-else">
                      <img src="/static/img/icon_tab_home_2.svg" alt="">
                  </div>
              </template>
          </van-tabbar-item>
          <van-tabbar-item to="live-list">
              <span class="home-footer-span">直播</span>
              <template #icon="props">
                  <div class="home-footer-icon">
                      <img src="/static/two/tabbar_live.svg" alt="">
                  </div>
              </template>
          </van-tabbar-item>
          <van-tabbar-item to="my">
              <span class="home-footer-span-else">我的</span>
              <template #icon="props">
                  <div class="home-footer-icon-else">
                      <img src="/static/img/icon_tab_me_2.svg" alt="">
                  </div>
              </template>
          </van-tabbar-item>
      </van-tabbar>

  </div>
</template>
<script>
import Interface from "@/util/interface"
import videoListSkeleton from "@/skeleton/videoListSkeleton"
export default {
    name: 'course-list',
    components :{
        'video-list-skeleton' : videoListSkeleton
    },
    data() {
        return {
            value: "",
            active: "",
            tabbar_active:1,
            category_id :0,
            category_index:0,
            category_child_id:0,
            banners: [],
            categories: [],
            categories_child:[],
            recommend:[],
            list:[],
            column:[],
            forecast:[],
            backs:[],
            loading:true,
            page:1,
            pageSize:10,
            total_page:1,
            swiperOption:{
                width:192,
                height:249,
                spaceBetween:15,
            },

            study:[],
            study_page:1,
            study_pageSize:10,
            study_total_page:1,
        }
    },
    methods: {
        onSearch(){
            this.study_page = 1
            this.fetch('study')
        },
        onCancel() {
            this.value = ""
            this.study_page = 1
            this.fetch("study")
        },
        fetch(scene) {
            if (scene === 'homepage') {
                let params = {
                    pageSize:999
                };
                if(this.value != ""){
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.home,params).then((res) => {
                    if(res.data.recommend){
                        this.column  = res.data.recommend
                    } else{
                        this.column = []
                    }
                    if (res.data.banners){
                        this.banners = res.data.banners
                    }else{
                        this.banners = [];
                    }
                    if(res.data.forecast){
                        this.forecast = res.data.forecast
                    }else{
                        this.forecast = []
                    }
                    Interface.getShareInfo(this,"直播","","")
                    setTimeout(()=>{this.loading = false},500)
                })
            } else if (scene === 'category') {
                Interface.getData('get', Interface.live.study_category).then((res) => {
                    if(res.data){
                        this.categories = res.data
                    }
                    this.categories.unshift({name:"推荐",id:0})
                    if(this.categories.length < 5){
                        for(let i=999;i<= (1007 - this.categories.length);i++){
                            this.categories.push({name:"",id:i})
                        }
                    }
                })
            }else if (scene === 'reBack') {
                this.page = 1
                let params = {
                    page:this.page,
                    pageSize:this.pageSize,
                }
                if(this.value != ""){
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.reBack,params).then((res) => {
                    if(res.data.list != null){
                        this.backs = res.data.list
                        this.total_page = res.data.total_page
                    }else{
                        this.backs = [];
                        this.total_page = 1
                    }
                    setTimeout(()=>{this.loading = false},500)
                })
            }else if (scene === 'study') {
                this.page = 1
                let params = {
                    page:this.study_page,
                    pageSize:this.study_pageSize,
                }
                if(this.value != ""){
                    params.title = this.value
                }
                Interface.getData('get', Interface.live.study,params).then((res) => {
                    if(res.data.list != null){
                        this.study = res.data.list
                        this.study_total_page = res.data.total_page
                    }else{
                        this.study = [];
                        this.study_total_page = 1
                    }
                    setTimeout(()=>{this.loading = false},500)
                })
            }
        },
        changeCategory(){
            this.category_id = this.categories[this.category_index].id
            this.fetch('homepage')
        },
        fetch_more(){
            this.study_page += 1
            let params = {
                page : this.study_page,
                pageSize:this.study_pageSize,
            }
            Interface.getData('get', Interface.live.study,params).then((res) => {
                this.study.push(...res.data.list)
                this.study_total_page = res.data.total_page
                console.log(this.study_page,this.study_total_page)
            })
        },
        go_detail(item){
            if(item.type === 2){
                this.$router.push({'name':'live-column',params:{id:item.id}})
            }else if(item.live_status === 6){
                this.$router.push({'name':'live-detail-home',params:{id:item.id}})
            }else {
                if(item.live_status === 0){
                    this.$router.push({'name':'live-detail',params:{id:item.id}})
                } else {
                    this.$router.push({'name':'live-detail-home',params:{id:item.id}})
                }
            }
        }
    },
    created() {
        this.fetch('banner')
        this.fetch('study')
        this.fetch('category')
        Interface.getShareInfo(this,"高博内训学术专区","","")
        sessionStorage.removeItem("search_data")
    },
}
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/live/study_list/index.vue